import { Component, OnInit, Inject } from "@angular/core";
import { PersonDataService } from "../core/persons.dataservice";
import { WorkGroupsDataService } from "../core/workgroups.dataservice";
import { WorkgroupPersonDataService } from "../core/workgrouppersons.dataservice";
import { SearchService, SumActivitiesQuery } from "../core/search.dataservice";
import { SummationGroupDataService } from "../core/summationgroups.dataservice";
import dataCore = require("../core/datacore");

@Component({
    selector: "crew-sum-activities",
    template: require('./activity-summation.component.html')
})
export class SumActivitiesComponent implements OnInit {

    constructor(
        @Inject(PersonDataService.Id) private personService: PersonDataService,
        @Inject(WorkGroupsDataService.Id) private workgroupService: WorkGroupsDataService,
        @Inject(WorkgroupPersonDataService.Id) private workgroupPersonService: WorkgroupPersonDataService,
        @Inject(SummationGroupDataService.Id) private summationGroupService: SummationGroupDataService,
        @Inject(SearchService.Id) private searchService: SearchService,
        @Inject("$q") private $q: ng.IQService,
        @Inject("$log") private $log: ng.ILogService) { }

    ngOnInit() {
        this.isLoading = true;

        this.$q
            .all([
                this.workgroupPersonService.getAll(),
                this.summationGroupService.getAll(),
                this.personService.getAll(),
                this.workgroupService.getAll()
            ])
            .then(res => {
                this.summationGroups = res[1].filter(e => e.Active);
                this.persons = res[2].filter(e => e.Active);
                this.workgroups = res[3].filter(e => e.Active);
                this.isLoading = false;
            })
            .catch(err => {
                this.$log.error(err);
                this.isLoading = false;
            });
    }

    public summationGroups: Nema.Crew.Model.ActivityTypeSummationGroup[] = [];

    public selectedSummationGroups: Nema.Crew.Model.ActivityTypeSummationGroup[] = [];

    public workgroups = [];

    public selectedPersons = [];

    public persons = [];

    public fromDate: Date = dataCore.getToday();

    public toDate: Date = dataCore.getToday();

    public isLoading: boolean = false;

    public selectedActivitySummationResult: ActivitySummationResult;

    public resultSummationGroupNames: string[] = [];
    public activitySummationResults: ActivitySummationResult[] = [];
    public showRowSums: boolean = false;
    public totalSums: number[] = [];

    public onSummationLineSelected(activitySummationResult: ActivitySummationResult) {
        if (this.selectedActivitySummationResult) {
            this.selectedActivitySummationResult.isSelected = false;
        }

        this.selectedActivitySummationResult = activitySummationResult;
        this.selectedActivitySummationResult.isSelected = true;
    }

    public compute() {

        // Clear the result, before computing the result
        this.selectedActivitySummationResult = null;
        this.isLoading = true;

        this.resultSummationGroupNames = [];
        this.activitySummationResults = [];
        this.showRowSums = false;
        this.totalSums = [];

        // Construct the query object
        var sumActivitiesQuery: SumActivitiesQuery = {
            From: dataCore.subtractTimezoneOffset(this.fromDate),
            To: dataCore.subtractTimezoneOffset(this.toDate),
            SummationGroupIds: this.selectedSummationGroups.map(sum => sum.Id),
            PersonIds: this.selectedPersons.map(person => person.Id)
        };

        // Perform the summation
        this.searchService
            .activitiesSum(sumActivitiesQuery)
            .then(res => {
                this.isLoading = false;
                this.createSearchResults(res.SummationLines.filter(a => a.Activities.length > 0), res.SummationGroups);
            })
            .catch(error => {
                this.$log.error(error);
                this.isLoading = false;
            });

    }

    private createSearchResults(summationLines: Nema.Crew.Model.ActivitySummationResultLine[], summationGroups: Nema.Crew.Model.NameSortTagId[]): void {
        this.showRowSums = summationGroups.length > 1;

        let summationGroupNames = summationGroups.map(summationGroup => summationGroup.Name);
        let lines: ActivitySummationResult[] = [];
        let totals: number[] = summationGroups.map(() => 0);

        if (this.showRowSums) {
            summationGroupNames.push("Row sum");
            totals.push(0);
        }

        for (let i = 0; i < summationLines.length; i++) {
            let summationLine = summationLines[i];
            let rowSum = 0;

            for (let j = 0; j < summationGroups.length; j++) {
                let currentValue = summationLine.Sums[j];
                rowSum += currentValue;
                totals[j] += currentValue;
            }

            if (this.showRowSums) {
                summationLine.Sums.push(rowSum);
                totals[summationGroups.length] += rowSum;
            }

            lines.push(new ActivitySummationResult(summationLine));
        }

        this.resultSummationGroupNames = summationGroupNames;
        this.activitySummationResults = lines;
        this.totalSums = totals;
    }
}

export class ActivitySummationResult {

    constructor(summationLine: Nema.Crew.Model.ActivitySummationResultLine) {
        this.summationLine = summationLine;
    }

    public summationLine: Nema.Crew.Model.ActivitySummationResultLine;

    public isSelected: boolean;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/compliance/activity-summation.component.ts